/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_4_AInputs */

const en_mk_faq_4_a = /** @type {(inputs: Mk_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Use the existing-project flow, connect a workspace through the CLI, or import a supported plan format. Automatic mode has its own stack requirements; not every codebase can run automatically.`)
};

const id_mk_faq_4_a = /** @type {(inputs: Mk_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Gunakan alur proyek yang sudah ada, hubungkan workspace melalui CLI, atau impor format rencana yang didukung. Mode otomatis memiliki kebutuhan stack tersendiri; tidak setiap codebase dapat langsung dijalankan otomatis.`)
};

/**
* | output |
* | --- |
* | "Yes. Use the existing-project flow, connect a workspace through the CLI, or import a supported plan format. Automatic mode has its own stack requirements; no..." |
*
* @param {Mk_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_4_a = /** @type {((inputs?: Mk_Faq_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_4_a(inputs)
	return en_mk_faq_4_a(inputs)
});